import { ReactNode, createContext, useState, useEffect } from 'react';
import { Client } from '@microsoft/microsoft-graph-client';
import { Providers } from '@microsoft/mgt-element';

// ----------------------------------------------------------------------
interface GraphClientContextProps {
  client: Client | undefined;
  token: string;
}

const initialState: GraphClientContextProps = {
  client: undefined,
  token: ''
};

const GraphClientContext = createContext(initialState);

type GraphClientProviderProps = {
  children: ReactNode;
};

function GraphClientProvider({ children }: GraphClientProviderProps) {
  const [token, setToken] = useState('');
  const graphClient = Client.initWithMiddleware({
    authProvider: Providers.globalProvider
  });
  const getToken = async () => {
    const data = await Providers.globalProvider.getAccessToken();
    setToken(data);
  };
  useEffect(() => {
    getToken();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Providers.globalProvider]);

  return (
    <GraphClientContext.Provider
      value={{
        client: graphClient,
        token
      }}
    >
      {children}
    </GraphClientContext.Provider>
  );
}

export { GraphClientProvider, GraphClientContext };
